import React from 'react';
import AddSousModuleDroit from './AddSousModuleDroit';
import ListeSousModuleDroit from './ListeSousModuleDroit';
import MyCard from '../../../../components/Common/MyCard';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../../util/apiClient';
import { ISousModuleDroit, setSousModuleDroits } from './sousModuleDroitSlice';
import { useDispatch } from 'react-redux';

const SousModuleDroit = () => {
    const dispatch = useDispatch();

    //les sous modules
    const getSousModulesDroitData = async () => {
        try {
            const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/listesousmoduledroit");
            if (res.status === 1) {
                const x = res.data.map((m: ISousModuleDroit) => {
                    return { ...m, id: m.idSousModuleDroit, libelle: m.libSousModuleDroit };
                });
                dispatch(setSousModuleDroits(x));
            } else {
                console.log("status !==1");
            }
        } catch (error) {
            console.log("🚀 ~ file: index.tsx:21 ~ getSousModulesDroitData ~ error:", error)
        }
    };

    React.useEffect(() => {
        getSousModulesDroitData();
    }, []);


    return (
        <div>
            <MyCard
                titleCard="Sous module"
                addComponent={<AddSousModuleDroit />}
                content={<ListeSousModuleDroit />}
            />
        </div>
    );
}

export default SousModuleDroit;
